// js
import './js/utilities.js';
import './js/cw-main.js';

// styles
import './scss/style.scss';

// images if you want to compress/convert etc. otherwise just get them from /src/